// Ritmo da curadoria: quantos produtos saem por dia e quantos as categorias
// escolhidas sustentam sem repetir produto.
//
// ponytail: ITEMS_PER_CATEGORY_PER_DAY e uma estimativa conservadora de ofertas
// NOVAS por categoria por dia depois dos filtros e do anti-repeticao de 7 dias.
// Ajustar com o historico real (auto_promotion_runs.status = 'empty') quando
// houver volume.
import { MINUTES_PER_DAY } from "../forwarding/window.js";
export const ITEMS_PER_CATEGORY_PER_DAY = 8;
const DAYS_PER_WEEK = 7;
/** Minutos abertos por dia (media semanal). Janela desligada = dia inteiro. */
export function openMinutesPerDay(window) {
    if (!window.enabled) {
        return MINUTES_PER_DAY;
    }
    const total = window.schedule.reduce((sum, interval) => sum + (interval ? Math.max(0, interval.end - interval.start) : 0), 0);
    return total / DAYS_PER_WEEK;
}
export function computePace(input) {
    const interval = Math.max(1, input.intervalMinutes);
    const cyclesPerDay = Math.floor(openMinutesPerDay(input.window) / interval);
    const configured = cyclesPerDay * Math.max(0, input.itemsPerCycle);
    const cappedByQuota = input.dailyQuota !== null && configured > input.dailyQuota;
    const productsPerDay = cappedByQuota ? input.dailyQuota : configured;
    const sustainablePerDay = Math.max(0, input.categoryCount) * ITEMS_PER_CATEGORY_PER_DAY;
    const minCategories = Math.max(1, Math.ceil(productsPerDay / ITEMS_PER_CATEGORY_PER_DAY));
    return {
        cyclesPerDay,
        productsPerDay,
        cappedByQuota,
        sustainablePerDay,
        minCategories,
        isSustainable: input.categoryCount >= minCategories,
    };
}
//# sourceMappingURL=pace.js.map